import React, { useEffect, useRef, useState } from 'react'
import { useLanguage } from '../../../../LanguageProvider';
import { CgCloseO } from 'react-icons/cg';
import { GrAttachment } from 'react-icons/gr';
import { IoCloseOutline, IoDocumentTextOutline } from 'react-icons/io5';
import AddModalInputField from '../../../../components/AddModalInputField/AddModalInputField';
import { TbStack2 } from 'react-icons/tb';
import '../AddSpeakerModal/AddSpeakerModal.css'
import { useToaster } from '../../../../ToasterProvider';

export default function AddSponsorModal({
    isOpen,
    onClose,
    onCreate
}) {
    const { toastError, toastSuccess, toastWarning } = useToaster();
    const fileInputRef = useRef();
    const { getTranslation } = useLanguage();
    const [companyTitle, setCompanyTitle] = useState("");
    const [title, setTitle] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [sponsorshipType, setSponsorshipType] = useState("");
    const [companyAbout, setCompanyAbout] = useState("");
    const [sponsorshipAbout, setSponsorshipAbout] = useState("");

    const resetStates = () => {
        setCompanyTitle("");
        setTitle("")
        setSelectedFiles([])
        setSponsorshipType("")
        setCompanyAbout("")
        setSponsorshipAbout("")
    }

    useEffect(() => {
        if (!isOpen) {
            resetStates();
        }
    }, [isOpen]);

    if (!isOpen) return null;


    const handleClose = () => {
        onClose();
        resetStates()
    }

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1]; // "data:image/jpeg;base64," kısmını kaldırıyoruz
                const extension = file.name.split(".").pop();
                const title =
                    file?.name?.substring(0, file.name.lastIndexOf(".")) || file?.name;
                setSelectedFiles((prevFiles) => [
                    ...prevFiles,
                    { file: base64String, extension: extension, title: title },
                ]);
            };
            reader.readAsDataURL(file);
        });
    };

    const removeFile = (index) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((file, i) => i !== index));
    };

    const allFieldsAreValid = () => {
        return (
            companyTitle.trim() !== "" &&
            sponsorshipAbout.trim() !== "" &&
            sponsorshipType.trim() !== "" &&
            companyAbout.trim() !== "" &&
            selectedFiles.length > 0
        );
    };

    const handleCreate = () => {
        if (!allFieldsAreValid()) {
            toastWarning(getTranslation("pleaseFillAllFields"))
        }
        else {
            onCreate(companyTitle, companyAbout, sponsorshipType, sponsorshipAbout, selectedFiles[0])
        }
    }



    return (
        <div className="add-speaker-modal-overlay">
            <div className="add-speaker-modal-container">
                <IoCloseOutline
                    className="add-speaker-modal-button close"
                    onClick={handleClose}
                />

                <p className="add-speaker-modal-title">
                    {getTranslation("addNewSponsor")}
                </p>

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("companyTitle") + "*"}
                    value={companyTitle}
                    onChange={(e) => setCompanyTitle(e.target.value)}
                    type={"text"}
                />

                <div className="add-task-modal-content">
                    <IoDocumentTextOutline
                        size={20}
                        style={{
                            width: "25px",
                            alignSelf: "flex-start",
                            marginTop: "10px",
                        }}
                    />
                    <textarea
                        className="add-task-modal-textarea"
                        style={{ height: '150px' }}
                        placeholder={getTranslation("companyAbout") + "*"}
                        value={companyAbout}
                        onChange={(e) => { setCompanyAbout(e.target.value); }} />
                </div>

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("sponsorshipType") + "*"}
                    value={sponsorshipType}
                    onChange={(e) => setSponsorshipType(e.target.value)}
                    type={"text"}
                />

                <div className="add-task-modal-content">
                    <IoDocumentTextOutline
                        size={20}
                        style={{
                            width: "25px",
                            alignSelf: "flex-start",
                            marginTop: "10px",
                        }}
                    />
                    <textarea
                        className="add-task-modal-textarea"
                        style={{ height: '150px' }}
                        placeholder={getTranslation("sponsorshipAbout") + "*"}
                        value={sponsorshipAbout}
                        onChange={(e) => { setSponsorshipAbout(e.target.value); }} />
                </div>



                <div
                    style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "6px",
                        display: "flex",
                    }}
                >
                    <span
                        style={{
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            display: "flex",
                            gap: "5px",
                        }}
                    >
                        <span className="add-event-modal-attachments-icon">
                            <GrAttachment />
                        </span>
                        <span className="add-event-modal-attachments">
                            {getTranslation("logo")}
                        </span>
                    </span>
                    <div className="add-event-modal-select-file-holder">
                        <button
                            className="action-button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            {getTranslation("selectFile")}
                        </button>
                        <input
                            type="file"
                            accept=".png,.jpg,.jpeg,.gif"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                    </div>


                    {selectedFiles.length > 0 && (
                        <div
                            style={{
                                display: "flex",
                                overflowX: "auto",
                                gap: "8px",
                                padding: "8px 0",
                                width: "100%",
                            }}
                        >
                            {selectedFiles.map((file, index) => (
                                <div
                                    className="add-event-modal-added-attachment-chip"
                                    key={index}
                                >
                                    <span className="add-event-modal-added-attachment-chip-title">
                                        {file.title}
                                    </span>
                                    <CgCloseO
                                        onClick={() => removeFile(index)}
                                        style={{
                                            cursor: "var(--pointer)",
                                            minWidth: "14px",
                                            minHeight: "14px",
                                            width: "14px",
                                            height: "14px",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                </div>



                <div className="add-speaker-modal-actions">
                    <button
                        className="add-speaker-modal-button create"
                        onClick={handleCreate}
                    >
                        {getTranslation("create")}
                    </button>
                </div>
            </div>
        </div>
    );
}
